import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Pricing() {
  const tiers = [{
    id: 'pilot',
    label: 'Entry',
    name: 'PILOT',
    price: '$597',
    tagline: 'Start strong. Site + reviews + lead-capture.',
    popular: false,
    topFeatures: ['Mobile-First Website', 'Review Automation', '$50 Coupon Lead Form', 'XML Sitemap Submission', '1 Blog Post / Month']
  }, {
    id: 'copilot',
    label: 'Starter',
    name: 'CO-PILOT',
    price: '$1,197',
    tagline: 'Get in the game. Reviews, citations, weekly GBP posts.',
    popular: false,
    topFeatures: ['1Dash.Pro CRM Sub-Account', 'Reputation Management', 'Directory Listings', 'Weekly GBP Posts', '10 Branded Email Accounts']
  }, {
    id: 'autopilot',
    label: 'Growth',
    name: 'AUTOPILOT',
    price: '$2,697',
    tagline: 'Never miss a lead. AI chat, follow-up, CRM, monthly report.',
    popular: true,
    topFeatures: ['ThinkTank Chat (client AI hub)', '24/7 AI Chat (lead capture)', 'Form Auto-Follow-Up', '1Dash Email + SMS Marketing', 'Monthly Strategy Call']
  }, {
    id: 'command',
    label: 'Full System',
    name: 'COMMAND CENTER',
    price: '$5,197',
    tagline: 'AI team of 20. Marketing, sales, social, support — all running.',
    popular: false,
    topFeatures: ['Personalized MISTR (white-label)', 'Social Content + Posting', 'Facebook + Google Ads Management', 'Advanced Analytics Dashboard', '1000 Call Tracking Minutes']
  }];
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-teal/30 to-transparent" data-id="element-850" />

      <section className="section-padding bg-section-gradient relative overflow-hidden" data-id="element-851">
        {/* Subtle Ambient Glow Orbs */}
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-teal/5 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-852" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-purple/5 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-853" />

        <div className="inner-container relative z-10" data-id="element-854">
          <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-855">
            <span className="text-cyan-400 text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-856">
              Pricing
            </span>
            <h2 className="font-poppins font-extrabold text-4xl md:text-5xl leading-tight mt-4 text-white" data-id="element-857">
              Pick the tier that fits{' '}
              <span className="text-cyan-400" data-id="element-858">where you are.</span>
            </h2>
            <p className="text-steel text-lg mt-6" data-id="element-859">
              Upgrade any time. Every plan = MindStream.ing — your business,
              running itself.
            </p>
          </div>

          <div className="grid lg:grid-cols-4 gap-6 md:gap-8 max-w-[1400px] mx-auto" data-id="element-860">
            {tiers.map((tier, i) => <motion.div key={tier.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1,
            duration: 0.5
          }} className={`relative bg-[#0F1D3A] border rounded-2xl p-8 flex flex-col h-full ${tier.popular ? 'border-cyan-400 ring-2 ring-cyan-400 shadow-[0_0_60px_rgba(6,182,212,0.3)] lg:-translate-y-4' : 'border-white/10'}`} data-id="element-861">
                {tier.popular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-cyan-400 text-[#0F1D3A] px-4 py-1 rounded-full text-xs font-bold tracking-wider uppercase whitespace-nowrap" data-id="element-862">
                    Most Popular
                  </div>}

                <div className="mb-8 flex-1" data-id="element-863">
                  <span className="text-steel text-xs font-bold tracking-wider uppercase mb-2 block" data-id="element-864">
                    {tier.label}
                  </span>
                  <h3 className="font-poppins font-extrabold text-2xl text-white mb-4" data-id="element-865">
                    {tier.name}
                  </h3>
                  <div className="flex items-baseline gap-1 mb-4" data-id="element-866">
                    <span className="text-5xl font-poppins font-extrabold text-white" data-id="element-867">
                      {tier.price}
                    </span>
                    <span className="text-steel font-medium" data-id="element-868">/mo</span>
                  </div>
                  <p className="text-steel text-sm leading-relaxed min-h-[40px]" data-id="element-869">
                    {tier.tagline}
                  </p>
                </div>

                <div className="h-px bg-white/10 w-full mb-8" data-id="element-870" />

                <div className="flex-1 mb-8" data-id="element-871">
                  <ul className="space-y-3" data-id="element-872">
                    {tier.topFeatures.map((feat, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-steel" data-id="element-873">
                        <Check size={16} className="text-cyan-400 shrink-0 mt-0.5" data-id="element-874" />
                        <span data-id="element-875">{feat}</span>
                      </li>)}
                  </ul>
                </div>

                <Link to="/pricing" className={`w-full py-4 rounded-lg font-poppins font-semibold transition-all text-center block ${tier.popular ? 'bg-cyan-400 text-[#0F1D3A] hover:bg-cyan-300 shadow-[0_0_20px_rgba(6,182,212,0.4)]' : 'bg-white/10 text-white hover:bg-white/20'}`} data-id="element-876">
                  See Full Details
                </Link>
              </motion.div>)}
          </div>

          <div className="text-center mt-12" data-id="element-877">
            <Link to="/pricing" className="text-cyan-400 hover:text-cyan-300 font-semibold inline-flex items-center gap-2" data-id="element-878">
              Compare all features and tiers →
            </Link>
          </div>
        </div>
      </section>
    </>;
}